// extracted by mini-css-extract-plugin
module.exports = {"content":"_1i2LStEcsSgUa5ahoPVIoN","tabContainer":"_3qVjxhAE9BxlD4Vf4nA3-e","card":"_3wPaIbq4K37vnV4ct8QWwy","iconContainer":"_3mJHUIiMTXPyRry0-CKnYd"};